import React, { Component } from 'react';
import Big from 'big.js';
import timesCircle from 'assets/images/close.svg';
import { Input, Error } from 'library';
import styles from './styles';
import { css } from 'aphrodite';

class TilesSize extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isImperialSystem: this.props.isImperialSystem,
            isError: props.isError,
            isErrorFloorPart: props.isErrorFloorPart,
            widthError: true,
            heightError: true,
            areaError: true,
            isMultiple: props.isMultiple,
            tilesWidth: props.dimensions.tilesWidth,
            tilesHeight: props.dimensions.tilesHeight,
            visibleTilesWidth: '',
            visibleTilesHeight: '',
            visibleArea: '',
            area: props.dimensions.area
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.isImperialSystem !== this.props.isImperialSystem) {
            this.setState({isImperialSystem: this.props.isImperialSystem});
        }
        if(prevProps.isError !== this.props.isError) {
            this.setState({isError: this.props.isError},()=>{
                this.parentCallBack();
            });
        }
        if(prevProps.isErrorFloorPart !== this.props.isErrorFloorPart) {
            this.setState({isErrorFloorPart: this.props.isErrorFloorPart});
        }
        if(prevProps.isMultiple !== this.props.isMultiple) {
            this.setState({isMultiple: this.props.isMultiple});
        }
        if(prevProps.dimensions !== this.props.dimensions) {
            this.setState({
                tilesWidth: this.props.dimensions.tilesWidth,
                tilesHeight: this.props.dimensions.tilesHeight,
                area: this.props.dimensions.area
            });
        }
    }

    parentCallBack() {
        this.props.onTilesDimensionsEntered({
            tilesWidth: this.state.tilesWidth,
            tilesHeight: this.state.tilesHeight,
            area: this.state.area
        });
    }

    checkCharacter(value, calculationValue) {
        // Checks if there is a fraction in the input
        // 'value' is the value to display in the input with possible fraction for user readability
        // 'calculationValue' is the value converted to number for calculation only

        var valueSplitted;

        if (value.indexOf('/') > -1) {
            valueSplitted = value.split('/')
            value = valueSplitted[0] + '/' + valueSplitted[1]

            if (valueSplitted[1] === '' || valueSplitted[1] == 0) {
                calculationValue = valueSplitted[0]
            } else {
                calculationValue = new Big(valueSplitted[0]).div(new Big(valueSplitted[1]))
            }
        } else if (value.indexOf(',') > -1) {
            valueSplitted = value.split(',')
            value = valueSplitted[0] + '.' + valueSplitted[1]
            calculationValue =  value
        } else {
            calculationValue =  value
        }

        return { value, calculationValue }
    }

    updateInputs(e) {
        var value = e.target.value;

        switch (e.target.id) {
            case "tilesWidth":
                var { value, calculationValue } = this.checkCharacter(value, calculationValue);

                // Update input value
                this.setState({visibleTilesWidth: value})

                if(value.length > 0 || typeof value === 'number') {
                    this.setState({tilesWidth: calculationValue, widthError: false}, () => {
                        this.parentCallBack();
                    });
                } else {
                    this.setState({tilesWidth: calculationValue, widthError: true}, () => {
                        this.parentCallBack();
                    });
                }
                break;
            case "tilesHeight":
                var { value, calculationValue } = this.checkCharacter(value, calculationValue);

                // Update input value
                this.setState({visibleTilesHeight: value})

                if(value.length > 0 || typeof value === 'number') {
                    this.setState({tilesHeight: calculationValue, heightError: value === ""}, () => {
                        this.parentCallBack();
                    });
                } else {
                    this.setState({tilesHeight: calculationValue, heightError: true}, () => {
                        this.parentCallBack();
                    });
                }
                break;
            case "area":
                var { value, calculationValue } = this.checkCharacter(value, calculationValue);

                // Update input value
                this.setState({visibleArea: value})

                if(value.length > 0 || typeof value === 'number') {
                    this.setState({area: calculationValue, areaError: value === ""}, () => {
                        this.parentCallBack();
                    });
                } else {
                    this.setState({area: calculationValue, areaError: true}, () => {
                        this.parentCallBack();
                    });
                }
                break;
            default:
                break;
        }
    }

    render() {
        const {
            index,
            widthLabel,
            heightLabel,
            widthDescription,
            heightDescription,
            onClick,
            rowTitle,
            link,
            errorLabel,
            floorLabel,
            floorDescription,
            floorOperator,
            imageTile1,
            imageTile2,
            imgUrl,
        } = this.props;

        const number = index + 1;
        const isEvenNumber = number%2 === 0;

        return (
            <div className={css(styles.tileSizeRow)}>
                <div className={css(styles.tileSizeContent, this.state.isError && (this.state.areaError || this.state.heightError || this.state.widthError) && styles.contentError)}>
                    <div className={css(styles.tileSizeText)}>
                        <div className={css(styles.tileSizeCloseWrapper)}>
                            {this.state.isMultiple &&
                            <a href={link} className={css(styles.tileSizeClose)} onClick={(e) => {
                                onClick(e)
                            }}>
                                <img src={imgUrl + timesCircle} alt="close" />
                            </a>
                            }
                        </div>
                        {this.state.isMultiple &&
                        <div className={css(styles.tileSizeRowNumber)}>
                            <span>{rowTitle} {number}</span>
                        </div>
                        }
                        <div className={css(styles.inputsRegion)}>
                            <Input
                                id="tilesWidth"
                                small
                                label={widthLabel}
                                isImperialSystem={this.state.isImperialSystem}
                                description={widthDescription}
                                onChange={(e)=>this.updateInputs(e)}
                                value={this.state.visibleTilesWidth}
                                isError={this.state.isError && this.state.widthError}
                                isPrintable
                            />
                            <Input
                                id="tilesHeight"
                                small
                                label={heightLabel}
                                isImperialSystem={this.state.isImperialSystem}
                                operator="×"
                                description={heightDescription}
                                onChange={(e)=>this.updateInputs(e)}
                                value={this.state.visibleTilesHeight}
                                isError={this.state.isError && this.state.heightError}
                                isPrintable
                            />
                            {this.state.isMultiple &&
                            <Input
                                id="area"
                                label={floorLabel}
                                square
                                isImperialSystem={this.state.isImperialSystem}
                                operator={floorOperator}
                                description={floorDescription}
                                onChange={(e)=>this.updateInputs(e)}
                                value={this.state.visibleArea}
                                isError={(this.state.isError && this.state.areaError) || this.state.isErrorFloorPart}
                                isPrintable
                            />
                            }
                        </div>
                    </div>
                    <figure className={css(styles.figure)}>
                        <img className={css(styles.image)} src={isEvenNumber ? imageTile2 : imageTile1} alt="" />
                    </figure>
                </div>
                {this.state.isError && (this.state.areaError || this.state.heightError || this.state.widthError) &&
                <div className={css(styles.error)}>
                    <Error label={errorLabel}/>
                </div>
                }
            </div>
        );
    }
}

export default TilesSize;